import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment-timezone';
import { useFormContext, useWatch } from 'react-hook-form';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
import { API_LOCAL_DATE_TIME_FORMAT } from '@famly/vet_ts-utils_date-format';
export const FormHeaderValuesDialog = (props) => {
    var _a, _b;
    const formContext = useFormContext();
    const watchedValues = useWatch({ control: formContext === null || formContext === void 0 ? void 0 : formContext.control });
    return (_jsx(Box, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, backgroundColor: "n0", color: "n500", padding: 4, maxWidth: "300px", left: "200px", children: Object.entries((_b = (_a = props.formValues) !== null && _a !== void 0 ? _a : watchedValues) !== null && _b !== void 0 ? _b : {}).map(([key, value]) => (_jsxs(React.Fragment, { children: [_jsx(Text, { variant: "body", emphasized: true, children: key }), _jsx(Text, { variant: "body", children: printValue(value) })] }, key))) }));
};
function printValue(value) {
    if (Array.isArray(value)) {
        return value.map(printValue).join(',\n');
    }
    else if (typeof value === 'number') {
        return value.toString();
    }
    else if (!value || typeof value === 'string' || typeof value === 'boolean') {
        return value === null || value === void 0 ? void 0 : value.toString();
    }
    else if (moment.isMoment(value)) {
        return value.format(API_LOCAL_DATE_TIME_FORMAT);
    }
    return `Unknown value type: ${value}`;
}
